var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM9 5.25C8.68934 5.25 8.4375 5.50184 8.4375 5.8125V9.1875C8.4375 9.49816 8.68934 9.75 9 9.75C9.31066 9.75 9.5625 9.49816 9.5625 9.1875V5.8125C9.5625 5.50184 9.31066 5.25 9 5.25ZM9.75 11.625C9.75 12.0392 9.41421 12.375 9 12.375C8.58579 12.375 8.25 12.0392 8.25 11.625C8.25 11.2108 8.58579 10.875 9 10.875C9.41421 10.875 9.75 11.2108 9.75 11.625Z",
    fill: "#F94B50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeError);
export default __webpack_public_path__ + "static/media/NoticeError.490065cdfcb0ec4c397cb7fb633fa054.svg";
export { ForwardRef as ReactComponent };